import React from "react";
import { style, per, px, url, pos, rgba, ms, RBStyle } from "rosebox";
import useHover from "@react-hook/hover";

const wrapperStyle = (isHovering: boolean): RBStyle => ({
  cursor: "pointer",
  margin: px(isHovering ? 4 : 8),
  transition: ["margin", ms(isHovering ? 100 : 150), "ease-in-out"],
});

const backgroundStyle = (bg: string): RBStyle => ({
  backgroundImage: url(bg),
  backgroundPosition: pos(per(50), per(50)),
  paddingBottom: per(100),
  position: "relative",
  height: px(0),
  borderRadius: px(4),
  width: per(100),
  boxShadow: [rgba(0, 0, 0, 0.4), [px(0), px(4), px(10), px(0)]],
});

const logoWrapperStyle: RBStyle = {
  position: "absolute",
  bottom: px(0),
  right: px(0),
  left: px(0),
  top: px(0),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

const logoStyle = (logo: string): RBStyle => ({
  backgroundImage: url(logo),
  width: per(90),
  height: per(60),
  backgroundSize: "contain",
  backgroundPosition: pos(per(50), per(50)),
  backgroundRepeat: "no-repeat",
});

export const GameCard = ({
  logo,
  background,
  title,
  onClick,
}: {
  title: string;
  background: string;
  logo: string;
  onClick: () => any;
}) => {
  const target = React.useRef(null);
  const isHovering = useHover(target);
  return (
    <div ref={target} onClick={onClick} style={style(wrapperStyle(isHovering))}>
      <div style={style(backgroundStyle(background))}>
        <div style={style(logoWrapperStyle)}>
          <div style={style(logoStyle(logo))}></div>
        </div>
      </div>
    </div>
  );
};
